@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.dropdown-menu-section {
  &:not(:last-child) {
    > *:last-child {
      border-bottom: 1px solid @package-dropdown--border-color;
    }
  }
}

.dropdown-section-title {
  .truncate();
  padding: 0 10px;
  font-size: 13px;
  line-height: 36px;
  height: 36px;
  border-bottom: 1px solid @package-dropdown--border-color;
  background: @package-dropdown--background-color;
}
